import {BaseError} from './base-error';

export class AuthenticationError extends BaseError {
  public constructor(message: string = 'Authentication Error') {
    super(message);
  }
}
